import React, { FC, ReactNode } from "react";
import cn from "classnames";

interface Props {
  children: ReactNode;
  title: string;
  description?: string;
  className?: string;
  titleClassName?: string;
  descriptionClassName?: string;
}

export const ActionBanner: FC<Props> = ({
  children,
  title,
  description,
  className,
  titleClassName,
  descriptionClassName,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col justify-center items-center w-full gap-4 p-5 border border-black-base/20 rounded-20",
        className
      )}
    >
      <h3
        className={cn(
          "text-purple-base font-semibold text-center",
          titleClassName
        )}
      >
        {title}
      </h3>
      {children}
      {description && (
        <pre>
          <p className={cn("font-medium text-justify", descriptionClassName)}>
            {description}
          </p>
        </pre>
      )}
    </div>
  );
};
